export default `
mutation moveInCart($quoteUid: String!, $cartId: String!) {
    moveInCart(quoteUid: $quoteUid, cartId: $cartId)
}
`;
